<script>
import DsProgressBar from "JIX/components/ds/DsProgressBar.vue";
import T from "./TypeIndicator.i18n.js";

export default {
    emits: ['add-answer', 'remove-answer'],
    components: {
        DsProgressBar,
    },
    props: {
        question: {
            type: Array,
            required: true,
        },
        progress: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            T,
            inTransition: false,
            animationClass: "slide-next",
        };
    },
};
</script>

<template>
    <section class="container px-4 typeindicator">
        <div class="row justify-content-center py-4">
            <div class="col-md-6">
                <h2 class="mb-4">
                    {{ T.title() }}
                </h2>

                <p class="lead mb-4 d-none d-md-block">
                    {{ T.subtitle() }}
                </p>

                <DsProgressBar
                    :value="progress.answered"
                    :min="0"
                    :max="progress.total"
                    :label="T.completed()"
                    show-pct
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 offset-md-3">
                <TransitionGroup
                    tag="div"
                    class="row flex-nowrap overflow-visible"
                    :name="animationClass"
                    @before-enter="inTransition = true"
                    @after-leave="inTransition = false"
                >
                    <div class="col-12" :key="question[0].text">
                        <div class="row">
                            <div class="col-md-6 mb-4" v-for="choice in question" :key="choice.text">
                                <button
                                    :class="[{ 'hover-invert': !inTransition }, 'p-4 choice']"
                                    @click="
                                        animationClass = 'slide-next';
                                        !inTransition && $emit('add-answer', choice.outcome);
                                    "
                                >
                                    {{ choice.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                </TransitionGroup>
            </div>
        </div>

        <div class="row">
            <div class="offset-md-3 col-md-6">
                <button
                    class="btn btn-secondary"
                    v-if="progress.answered > 0"
                    @click="
                        animationClass = 'slide-previous';
                        !inTransition && $emit('remove-answer');
                    "
                >
                    {{ T.goBack() }}
                </button>
            </div>
        </div>

        <div class="row py-4 mt-auto">
            <div class="offset-md-3 col-md-6 text-center">
                <p class="small text-muted">
                    {{ T.frediFalk() }}
                </p>
            </div>
        </div>
    </section>
</template>
